export const DOCUMENT_GENERATION_ACCESS_TOKEN_COOKIE_NAME =
  "document-generation-user-access-token";
export const DOCUMENT_GENERATION_REFRESH_TOKEN_COOKIE_NAME =
  "document-generation-user-refresh-token";
